module.exports = __webpack_public_path__ + "img/icon_updates.6e3e0dab.svg";